export { Affix } from './affix';
export type { AffixProps } from './affix';
